import Service from '../Service'
import AuthService from '../AuthService'

const User = {
    getUserList(page) {
        return AuthService.get("/api/show-all-user?page="+page).then(res => {
            return res;
        });
    },
    getAdminList(page) {
        return AuthService.get("/api/show-all-admin?page="+page).then(res => {
            return res;
        });
    },
    getReviewerList() {
        return AuthService.get("/api/show-all-reviewer").then(res => {
            return res;
        });
    },
    getUserById(id) {
        return AuthService.get(`/api/get-user-by-id/${id}`).then(res => {
            return res;
        });
    },
    getCertificateList(page) {
        return AuthService.get("/api/show-all-certificate-user?page="+page).then(res => {
            return res;
        });
    },
    updateCertificate(data,id) {
        return AuthService.put(`/api/update-certificate-status/${id}`, data).then(res => {
            return res;
        });
    },
    remakeCertificate(id) {
        return AuthService.get(`/api/remake-certificate/${id}`).then(res => {
            return res;
        });
    },
    verifyReviewer(id) {
        return AuthService.post(`/api/verify-reviewer?reviewerID=${id}`).then(res => {
            return res;
        });
    },
    updateUser(data,id) {
        return AuthService.put(`/api/update-user-status/${id}`, data).then(res => {
            return res;
        });
    },
    getResearcherType() {
        return AuthService.get('/api/show-researcher-type');
    },
    searchAdmin(searchData) {
        return AuthService.get('/api/search-admin?researcherName='+searchData.researcherName+'&typeID='+searchData.typeID).then(res => {
            return res;
        });
    },
    searchResearcher(searchData) {
        return AuthService.get('/api/search-researcher?researcherName='+searchData.researcherName).then(res => {
            return res;
        });
    },
    deleteUser(id) {
        return AuthService.delete(`/api/delete-user/${id}`).then(res => {
            return res;
        });
    },
    changeUserStatus(data) {
        return AuthService.post(`/api/update-user-remark`, data).then(res => {
            return res;
        });
    },
}

export default User;
